import { Link } from "react-router-dom";
import { ArrowRight, User } from "lucide-react";
import { SiteHeader } from "../../components/site/SiteHeader";
import { SiteFooter } from "../../components/site/SiteFooter";
import { PageHero } from "../../components/site/PageHero";
import { CTABand } from "../../components/site/CTABand";
import { Reveal, Stagger, StaggerItem } from "../../components/motion/Reveal";

const TEAM = [
  { name: "Leadership", role: "Founder & CEO" },
  { name: "Operations", role: "Head of Operations" },
  { name: "Technical", role: "Technical Lead — Security Systems" },
  { name: "Projects", role: "Project Manager — Installations" },
  { name: "Field", role: "Senior Field Engineer" },
  { name: "Support", role: "Customer Support & AMC Desk" },
];

export default function Team() {
  return (
    <div className="font-publicsans bg-nx-navy text-slate-200 antialiased" data-testid="team-page">
      <SiteHeader />
      <PageHero
        crumb="Our Team"
        eyebrow="Our Team"
        title="The people behind"
        titleAccent="the systems."
        description="A compact, hands-on team of engineers, project managers and support specialists — every installation is supervised end-to-end by us."
      />
      <section className="py-16 sm:py-24">
        <div className="nx-wrap">
          <Stagger className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
            {TEAM.map((m) => (
              <StaggerItem key={m.role}>
                <div className="h-full bg-nx-navy p-8 flex flex-col items-center text-center gap-4" data-testid={`team-card-${m.role.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                  <span className="flex items-center justify-center w-20 h-20 rounded-full bg-nx-gold/[0.08] border border-nx-gold/30">
                    <User size={30} className="text-nx-goldlight" strokeWidth={1.25} />
                  </span>
                  <div>
                    <p className="font-marcellus text-lg text-white">{m.name}</p>
                    <p className="text-[11px] tracking-[0.18em] uppercase text-nx-goldlight mt-1.5">{m.role}</p>
                  </div>
                </div>
              </StaggerItem>
            ))}
          </Stagger>
          <Reveal delay={0.15} className="mt-12">
            <p className="text-xs text-slate-600 leading-relaxed max-w-2xl" data-testid="team-placeholder-note">Individual profiles and photographs are being added as the team grows. Names and photos appear here with each member&apos;s consent.</p>
            <Link to="/inquiries" className="group inline-flex items-center gap-3 mt-8 bg-nx-gold hover:bg-nx-goldlight text-nx-navy font-semibold text-sm tracking-wide px-9 py-4 transition-all duration-300 hover:-translate-y-0.5" data-testid="team-cta-inquiries">
              Work With Us <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </Reveal>
        </div>
      </section>
      <CTABand />
      <SiteFooter />
    </div>
  );
}
